<template>
  <div class="mt-130">
    <h5 class="text-center">گالری تصاویر تراک میکسر بتن | سبلان میکسر</h5>
    <div class="container">
      <span> تعداد تصاویر : {{ images.length }} </span>
    </div>

    <hr />
    <div
      style="display: block; margin: 0 auto; text-align: center"
      class="container"
    >
      
      <div class="card-item" v-for="item in images" :key="item.fileName">
        <a class="gallery-lightbox" :href="item.fileName">
          <img v-lazy="item.fileName" class="image-item" alt="" />
        </a>
      </div>      
    
      <div class="card-item-clear"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      images: "controlPanelX/imagesResult",
    }),
  },
  methods: {   
  },
  created() {
    this.$store.dispatch("controlPanelX/getImages");
  },
};
</script>

<style scoped>
.mt-130 {
  margin-top: 130px;
}
.image-item {
  /* width: 95%; */
  height: 300px;
  margin: 10px;
  border-radius: 5px;
}
.card-item {
  display: inline;
  /* float: right; */
  /* width: 33.33%; */
}
.card-item img {
  box-shadow: -1px 5px 5px 0px rgba(0, 0, 0, 0.18);
  -webkit-box-shadow: -1px 5px 5px 0px rgba(0, 0, 0, 0.18);
  -moz-box-shadow: -1px 5px 5px 0px rgba(0, 0, 0, 0.18);
}
.card-item-clear {
  clear: both;
}
@media only screen and (max-width: 600px) {
  .card-item {
    float: right;
    width: 100%;
  }
}
</style>